/**
 * Shows up or hide final sale label on PDP
 * @param {Array<Object>} results - array of object with relevant information about final sale
 */
export const renderFinalSale = (results) => {
  const sizeActive = document.querySelector('.pdp-c-atc-size-selector__size-item--active');
  const soldOutSizes = document.querySelectorAll('.pdp-c-atc-size-selector__size-item--sold-out');
  const finalSale = document.querySelector('span[aria-label="Final Sale item"]');
  const ctaBtn = document.querySelector('.pdp-c-atc__submit-btn');

  // Show or keep hidden mail icons on sold out sizes
  soldOutSizes.forEach((sos) => {
    if (results.some((r) => r.id === sos.dataset.variantId && !r.finalSale))
      sos.nextElementSibling.classList.remove('pdp-c-atc-size-selector__email-asset--hidden');
  });

  if (!sizeActive) return;

  if (
    sizeActive.classList.contains('pdp-c-atc-size-selector__size-item--sold-out') &&
    results.some((result) => result.id === sizeActive.dataset.variantId && result.finalSale)
  ) {
    finalSale.style.display = 'flex';
    ctaBtn.classList.remove('pdp-c-atc__submit-btn--waitlist');
    ctaBtn.setAttribute('data-waitlist-open', 'false');
    ctaBtn.classList.add('pdp-c-atc__submit-btn--soldout');
    ctaBtn.querySelector('span').textContent = 'Sold Out';
  } else if (
    !sizeActive.classList.contains('pdp-c-atc-size-selector__size-item--sold-out') &&
    results.some((result) => result.id === sizeActive.dataset.variantId && result.finalSale)
  ) {
    finalSale.style.display = 'flex';
  } else if (!results.some((result) => result.id === sizeActive.dataset.variantId && result.finalSale)) {
    ctaBtn.classList.remove('pdp-c-atc__submit-btn--soldout');
    finalSale.style.display = '';
  }
};
